import { SVGProps, useId } from 'react';

export function IconAIAvatar(props: SVGProps<SVGSVGElement>) {
  const gradientId = `ai-avatar-gradient-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="16" cy="16" r="16" fill={`url(#${gradientId})`} />
      <g transform="translate(8 8) scale(1)">
        <path
          d="M8 16C8 14.8933 7.78669 13.8533 7.36 12.88C6.94669 11.9067 6.38 11.06 5.66 10.34C4.94 9.62 4.09333 9.05331 3.12 8.64C2.14667 8.21332 1.10667 8 0 8C1.10667 8 2.14667 7.79331 3.12 7.38C4.09333 6.95331 4.94 6.38 5.66 5.66C6.38 4.94 6.94669 4.09333 7.36 3.12C7.78669 2.14667 8 1.10667 8 0C8 1.10667 8.20669 2.14667 8.62 3.12C9.04669 4.09333 9.62 4.94 10.34 5.66C11.06 6.38 11.9067 6.95331 12.88 7.38C13.8533 7.79331 14.8933 8 16 8C14.8933 8 13.8533 8.21332 12.88 8.64C11.9067 9.05331 11.06 9.62 10.34 10.34C9.62 11.06 9.04669 11.9067 8.62 12.88C8.20669 13.8533 8 14.8933 8 16Z"
          fill="#ffffff"
        />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="32" y1="0" x2="0" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1BA1E3" />
          <stop offset="0.55" stopColor="#1E5BC6" />
          <stop offset="1" stopColor="#003399" />
        </linearGradient>
      </defs>
    </svg>
  );
}
